
( function( $ ) {

    var overlay = {
        wrapper: $('body'),

        init: function () {
            $('.js-trigger-mobile-menu').on('click', $.proxy(this.handleClick, this));
        },

        handleClick: function () {
            this.wrapper.toggleClass('mobile-nav-is-active');
        }
    };

    overlay.init();

    //change HTML header single training DIt vind je ook interessant
    if( $( '.wpg-wdp-product-block.wpg-wdp-product-block_other_products' ).length ) {
        $( '.wpg-wdp-product-block_other_products .wpg-wdp-product-block-header' ).replaceWith( '<div class="hr"><div class="hr-container"><div class="btn--large"><h2 class="hr-heading heading heading--alt">Dit vind je misschien ook interessant</h2></div></div></div>' );
    }

    // Hide cross/close icon when field is empty
    $( '.advice-search-input' ).on('keypress', function() {
        $('.advice-clear-filters-button').css('visibility','visible');
    });

    //change size of first spotlight element when it is a video
    if( $( '.spotlight.container' ).length ) {
        if( $( '.spotlight.container .first-item .excerpt-header' ).hasClass( 'video' ) ) {
            $( '.spotlight.container .col-lg-7').addClass( 'col-lg-8' ).removeClass( 'col-lg-7' );
            $( '.spotlight.container .col-lg-5').addClass( 'col-lg-4' ).removeClass( 'col-lg-5' );
            $( '.spotlight .col-md-6 .excerpt-header' ).css( 'height', '207px' );
            $( '.spotlight .col-md-6 .excerpt-header .image' ).css( 'height', '207px' );
        }
    }

    //share buttons article
    if( $( '.share' ).length ) {
        $( '.share__item__button--facebook' ).on('click', function( e ) {
            e.preventDefault();
            window.open( $( this ).attr( 'href' ), "", "toolbar=0, status=0, width=900, height=500" );
        } );
        $( '.share__item__button--twitter' ).on('click', function( e ) {
            e.preventDefault();
            window.open( $( this ).attr( 'href' ), "", "toolbar=0, status=0, width=900, height=500" );
        } );
    }


    if( window.device && window.device === "mobileonly" ) {
        if( $( ".single-theme" ).length ) {
            $( '.theme-items .excerpt' ).not( '.excerpt--mini' ).addClass( 'excerpt--mini' );
        }
        if( $( ".single-redacteur .latest-updates" ).length ) {
            $( '.latest-updates .excerpt' ).not( '.excerpt--mini' ).addClass( 'excerpt--mini' );
        }
    }


    if( $( ".article-readmore" ).length > 0 ) {
        $( ".article-readmore" ).on('click', function( event ){
            var elementHeight = $( ".digi_subscription" ).height();
            var scroll = elementHeight + 75;
            $( 'html, body' ).animate( { scrollTop: '+=' + scroll + 'px' }, 800 );
        } );
    }



    //academy show more items
    $( ".btn-center-container .btn--outline" ).on('click', function() {
        $( ".trainingen__faq__item__hide" ).slideToggle( "slow" );
        $( ".btn-center-container .btn--outline" ).css( 'display', 'none' );
    });


    /**
     * AJAX filter HTML injector
     */
    $('form[data-filter-target]').on('change', function(e) {
        var target = $(this).data('filter-target');
        var $target = $(target);
        var url = window.location.href.split('?')[0];
        var data = $(this).serialize();

        $target.addClass('is-loading');

        $.get(url, {filter: data})
            .done(function(response) {
                var html = $(response).find(target);
                $target.replaceWith(html);
            })
            .always(function() {
                $target.removeClass('is-loading');
            });

    });

    /**
     * set header of card at same height
     */
    if( $('.wpg-abo-card-header' ).length ) {
        var elementHeight = 0;
        $(".wpg-abo-card-header").each(function (id, header) {
            if ($(header).height() > elementHeight) {
                elementHeight = $(header).height();
            }
        }).height(elementHeight);
    }
} )( jQuery );
